import { useShipmentsOverviewContext } from '@/modules/pmt/context';
import { CustomAdsense } from './MyParcelsLeftAd.styles';
import { PMTAdType } from '../../constants';

export const MyParcelsLeftAd = () => {
  const { noShipmentsAdded } = useShipmentsOverviewContext();

  if (!noShipmentsAdded) return null;

  return <CustomAdsense className='pmt-below-parcel-list' variant={PMTAdType.PMT_SQUARE_AD} />;
};
